export default __webpack_public_path__ + "static/media/cortex_data_lake_diagram.5a97ffbc.png";